// removed by extract-text-webpack-plugin
module.exports = {"loading_container":"G51a6a2","loading_image_container":"Gc20893","loading_image":"Ga325a6"};